import useMutation from "src/hooks/useMutation";

function useBankInfoUpdate(id) {
  return useMutation({
    path: `/api/v1/bank-infos/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/bank-infos`,
      shouldRevalidate: true,
    },
  });
}

export default useBankInfoUpdate;

